import Countdown from 'countdown-js';

class Timer {

  constructor(elem) {
    this.timer = elem;
	}

  initialize() {
    let timer = this.timer;
    let days = timer.find('[data-timer-day]');
    let hours = timer.find('[data-timer-hours]');
    let minutes = timer.find('[data-timer-min]');
    let seconds = timer.find('[data-timer-sec]');

    let date = new Date(timer.attr('data-timer'));
    Countdown.timer(date, function(timeLeft) {
      days.text(testTime(timeLeft.days))
      hours.text(testTime(timeLeft.hours))
      minutes.text(testTime(timeLeft.minutes))
      seconds.text(testTime(timeLeft.seconds))

    }, function() {
      timer.hide();
      timer.closest('[data-timer-wrap]').hide();
      console.log("Countdown Finished!")
    })

    function testTime(value) {
      let result;

      if (value < 10) {
        result = '0' + value
      } else {
        result = value;
      }

      return result;
    }
	}
}

export {Timer};

$(function () {
  window.Timer = Timer;
});

$(window).on('load', () => {
  let timer = [];

  if ($('[data-timer]').length > 0) {
		$('[data-timer]').each(function(i) {
			timer[i] = new Timer($(this));
			timer[i].initialize();
		});
	}
});
